import { ServiceScriptsList } from "@/App/ServiceScripts/Table";

export function PageList() {
  return <ServiceScriptsList />;
}
